import React, { useEffect } from 'react';
import MagicianDoseSelectionForm from './MagicianDoseSelectionForm';
import MagicianDrugSelectionForm from './MagicianDrugSelectionForm';
import { useFormikContext } from 'formik';
import { useLocation } from 'react-router-dom';
import * as Routes from 'app/constants/Routes';

type Props = {
  firstTimeChoice?: boolean;
  handleSubmit?: () => void;
  changeProductHandler?: ((kingProductType: string, setFieldValue: any) => void) | null;
  starter_pack: boolean;
  available_doses: string[];
};

const MagicianProductSelectionForm = ({
  firstTimeChoice = true,
  handleSubmit = undefined,
  changeProductHandler = null,
  starter_pack = false,
  available_doses = [],
}: Props) => {
  const location = useLocation();
  const { values, setFieldValue } = useFormikContext<{
    current_product_step: string;
  }>();

  useEffect(() => {
    if (!values.current_product_step) {
      setFieldValue('current_product_step', 'dose');
    }
  }, []);

  const handleSubmitAndResetCurrentStep = () => {
    handleSubmit?.();
    if (location.pathname === Routes.UpdateSubscription) {
      setFieldValue('current_product_step', 'dose');
    }
  };

  return (
    <>
      {values.current_product_step === 'dose' && (
        <MagicianDoseSelectionForm
          available_doses={available_doses}
          handleSubmit={() => setFieldValue('current_product_step', 'drug')}
        />
      )}
      {values.current_product_step === 'drug' && (
        <MagicianDrugSelectionForm
          available_doses={available_doses}
          handleSubmit={handleSubmitAndResetCurrentStep}
          firstTimeChoice={firstTimeChoice}
          starter_pack={starter_pack}
          changeProductHandler={changeProductHandler}
        />
      )}
    </>
  );
};

export default MagicianProductSelectionForm;
